import { Button, ButtonGroup } from "@shopify/polaris";
import {
  UPDATES_FREQUENCY_EVERY_MANUAL,
  UPDATES_FREQUENCY_EVERY_PERIOD,
  UPDATES_FREQUENCY_EVERY_SCHEDULED
} from "../../../../../../../../constants/updatesFrequencyTypes.js";
import { useCallback } from "react";
import styles from "../UpdatesFrequencyCard.module.css";

const UpdatesFrequencyTypeButtons = ({ input }) => {

  const handleChangeType = useCallback((value) => {
    input.onChange({ ...input.value, type: value });
  }, [input]);

  return (
    <ButtonGroup segmented>
      <div className={styles["button-wrapper"]}>
        <Button
          primary={input.value.type === UPDATES_FREQUENCY_EVERY_PERIOD}
          onClick={() => {
            handleChangeType(UPDATES_FREQUENCY_EVERY_PERIOD);
          }}
        >
          Frequency
        </Button>
      </div>
      <Button
        primary={input.value.type === UPDATES_FREQUENCY_EVERY_SCHEDULED}
        onClick={() => {
          handleChangeType(UPDATES_FREQUENCY_EVERY_SCHEDULED);
        }}
      >
        Scheduled
      </Button>
      <Button
        primary={input.value.type === UPDATES_FREQUENCY_EVERY_MANUAL}
        onClick={() => {
          handleChangeType(UPDATES_FREQUENCY_EVERY_MANUAL);
        }}
      >
        Manual
      </Button>
    </ButtonGroup>
  );
};

export default UpdatesFrequencyTypeButtons;